import { DocumentReferenceNode as DocumentReferenceSchema } from '@seen/core/tiptap/schema'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { DocumentReferenceNodeComponent } from '#src/components/rich-text-editor/document-reference/DocumentReferenceNodeComponent.tsx'

export const DocumentReferenceNode = DocumentReferenceSchema.extend({
  addNodeView() {
    return ReactNodeViewRenderer(DocumentReferenceNodeComponent, {
      className: 'mb-4',
    })
  },
})
